import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { array, fallback, object, optional, picklist, pipe, string, transform } from "valibot";

export const BOOKING_VIEWS = ["schedule", "year", "month", "week", "day"] as const;
export type BookingView = (typeof BOOKING_VIEWS)[number];

export const Route = createFileRoute("/supplier/$supplierId/bookings")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Bookings")),
  validateSearch: object({
    calendars: fallback(optional(array(string())), undefined),
    view: fallback(optional(picklist(BOOKING_VIEWS), "week"), "week"),
    date: fallback(pipe(optional(string(), ""), transform(stringToDate)), new Date()),
  }),
  beforeLoad: () => ({
    breadcrumb: "Bookings",
  }),
  head: () => ({
    meta: seo({ title: "Bookings" }),
  }),
});

function stringToDate(dateStr: string) {
  const date = new Date(dateStr);
  if (!isNaN(date.getTime())) {
    return date;
  }
  return new Date();
}
